import React, { useState } from 'react';
import Select from 'react-select';
import InputField from 'components/common/Study/InputField/index';
import { customStylesV2 } from 'components/common/Dropdown/DropDownListHelper';
import styles from '../styles.scss';
import { useEffect } from 'react';
import { Conditional } from '../../../../../common/components/layout/index';
import ChevronIcon from 'components/common/ChevronFaIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { AddingUserOptions } from '../constants';
import MultipleSelect from '../../../../delegationOfAuthority/v2/containers/DelegationSidePanel/DelegationDrawer/DelegationSection/MultiSelectWithCheckBox';
/**
 * @typedef {object} UserAndAccessProps
 * @property {Array.<object>} userList
 * @property {Array.<object>} multiUserList
 * @property {Array.<object>} accessLevel
 * @property {object} studyAccessLevel
 * @property {boolean} isEditMode
 */

/**
 * The select user and study access step.
 * 
 * @param {UserAndAccessProps} props
 */
export function UserAndAccess(props) {
    const usersOptions = props.userList;
    const [state, setState] = useState({
        user: undefined,
        access: undefined,

    });
    const [multiUser, setMultiUser] = useState({
        users: [],
        access: undefined,

    });

    useEffect(() => {
        if (props.studyAccessLevel.user && props.studyAccessLevel.access) {
            setState(props.studyAccessLevel);
        }
    }, [props.studyAccessLevel]);

    useEffect(() => {
        if (props.onSelected) {
            props.onSelected(props.singleOrMulti == AddingUserOptions.single ? state : { ...multiUser, access: state.access });
        }
    }, [state.user, state.access, multiUser]);

    const isAccessSelectDisabled = () => {
        return (
            props.studyAdminCount <= 1 &&
            props.isEditMode &&
            props.studyAccessLevel.access &&
            props.studyAccessLevel.access.value === 'admin' &&
            props.currentAccessLevel === 'admin'
        );
    };

    return (<div>
        <Conditional condition={!props.isEditMode}>
            <Conditional condition={props.singleOrMulti == AddingUserOptions.single}>
                <InputField
                    required={true}
                    label='Select User'
                    htmlFor='user'
                    customClasses={{
                        inputWrapper: styles.inputWrapper
                    }}
                >
                    <Select
                        id='user'
                        name='user'
                        placeholder='Select User'
                        value={props.studyAccessLevel.user}
                        options={usersOptions}
                        data-cy="add-users-modals-user-select-list"
                        styles={customStylesV2}
                        onChange={(value) => setState({ ...state, user: value })}
                        className={props.error.user && styles.errorInput}
                        components={{
                            DropdownIndicator: () => <ChevronIcon isOpen={Boolean(false)} customStyles={{ padding: '4px', paddingRight: '8px' }} />
                        }}
                    />
                </InputField>
            </Conditional>

            <Conditional condition={props.singleOrMulti == AddingUserOptions.multiple}>
                <InputField
                    htmlFor='user'
                    customClasses={{
                        inputWrapper: styles.padding0
                    }}

                >
                    <MultipleSelect
                        handleChange={(e) => {
                            setMultiUser({ ...multiUser, users: e });
                        }}
                        id='user'
                        options={props.allUsers}
                        selectedValues={multiUser.users}
                        label='Select Users'
                        placeHolder='Select Users'
                        canSelectAll={false}
                        groupOptions={props.multiUserList}
                        errorField={props.error.user && styles.errorInput}
                    />
                </InputField>
            </Conditional>
            {props.error.user && <label className={styles.errorText}>User is required</label>}

        </Conditional>
        <InputField
            required={true}
            label='Access Level'
            htmlFor='access'
            customClasses={{
                inputWrapper: styles.inputWrapper
            }}
        >
            {(isAccessSelectDisabled() ? <p className={styles.accessError}>Admin</p> : <Select
                id='access'
                name='access'
                value={props.studyAccessLevel.access}
                placeholder='Select Access Level'
                options={props.accessLevel}
                data-cy="add-users-modals-user-select-list"
                styles={customStylesV2}
                onChange={(value) => setState({ ...state, access: value })}
                className={props.error.access && styles.errorInput}
                components={{ DropdownIndicator: () => <ChevronIcon isOpen={Boolean(false)} customStyles={{ padding: '4px', paddingRight: '8px' }} /> }}
            />)}
            {props.error.access && <label className={styles.errorText}>Access level is required</label>}
            {isAccessSelectDisabled() && (
                <div className={styles.note}>
                    <div className={styles.iconWrapper}>
                        <FontAwesomeIcon icon={faCircleInfo} />
                    </div>
                    <div className={styles.textWrapper}>
                        <p>
                            {props.studyAccessLevel && props.studyAccessLevel.user && props.studyAccessLevel.user.label} is the only Admin on this Study.
                        </p>
                        <p>
                            To change their Access Level, you must assign another Admin.
                        </p>
                    </div>
                </div>
            )}
        </InputField>
    </div>);
}